import { useEffect } from 'react';
import styles from './SuccessToast.module.scss';

interface SuccessToastProps {
  message: string;
  onClose: () => void;
  duration?: number;
}

export default function SuccessToast({
  message,
  onClose,
  duration = 3000,
}: SuccessToastProps) {
  useEffect(() => {
    const timeout = setTimeout(onClose, duration);
    return () => clearTimeout(timeout);
  }, [duration, onClose]);

  return (
    <div
      className={`${styles['wrapper']} alert alert-success alert-dismissible`}
      role="status"
    >
      <i className={`icon fas fa-solid fa-check ${styles['icon']}`}></i>
      <span className={styles['text']}>{message}</span>
      <button
        type="button"
        className="close"
        aria-label="Close"
        onClick={onClose}
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  );
}
